// ==============================|| MENU ITEMS - ADMINISTRADOR ||============================== //

const adminMenu = {
  id: 'group-admin',
  title: 'Módulo de Gestión',
  type: 'group',
  children: [
    {
      id: 'admin-panel',
      title: 'Administrador',
      icon: 'ph ph-user-gear',
      type: 'collapse',
      children: [
        
        {
          id: 'listar-usuarios',
          title: 'Listar y Editar Usuarios',
          type: 'item',
          url: '/admin/listar-usuarios'
        },
        {
          id: 'gestion-entidades',
          title: 'Gestionar Entidades',
          type: 'item',
          url: '/admin/gestion-entidades'
        },
        {
          id: 'gestion-roles',
          title: 'Gestionar Roles',
          type: 'item',
          url: '/admin/gestion-roles'
        },
        {
          id: 'seguimiento-cargas',
          title: 'Seguimiento de Cargas',
          type: 'item',
          url: '/admin/seguimiento-cargas'
        }
      ]
    }
  ]
};

export default adminMenu;